import styles from "./FolderContentEmailTreeView.module.less";
import classNames from "classnames";
import { Icon, Spinner } from "client/Components";
import { setTrackingId } from "client/Misc/utils";

export type FolderContentEmailTreeViewProps = {
	folderName: string;
	count?: number;
	isCounterBold?: boolean;
	status?: "loading" | "error" | "success";
};

export const FolderContentEmailTreeView = (props: FolderContentEmailTreeViewProps) => {
	const {
		folderName,
		count,
		isCounterBold = false,
		status
	} = props;
	return (
		<div className={styles.root} >
			<span
				{...setTrackingId("name")}
				className={styles.name}>
				{folderName}
			</span>
			{status === "loading" && <Spinner isInline />}
			{status === "error"
				&& (
					<Icon
						value={{
							kind: "font",
							name: "triangle-exclamation",
							color: "danger"
						}}
					/>
				)
			}
			{Boolean(count) && (
				<span
					{...setTrackingId("count")}
					className={classNames(styles.count, {
					[styles.count_bold]: isCounterBold
				})}>
					{count}
				</span>
			)}
		</div>
	);
};
FolderContentEmailTreeView.displayName = "FolderContentEmailTreeView";
